<template>
  <PageWrap
    :heading="$t('admin.invoices_and_receipts.title')"
    useForm
    @submit="emit('submit')"
  >
    <Flex
      direction="column"
      align="center"
      justify="center"
    >
      <BaseCard
        fullWidth
        :heading="$t('admin.invoices_and_receipts.invoice_settings.title')"
      >
        <LogoDescription />
      </BaseCard>
      <BaseCard
        fullWidth
        :heading="$t('admin.invoices_and_receipts.receipt_settings.title')"
      >
        <BaseCheckbox
          v-model="formData.settings.sales.thermalSupport"
          :label="
            $t('admin.invoices.permissions.support_thermal_printer')
          "
          v-test="'thermalSupport'"
        />
      </BaseCard>
    </Flex>
    <template #actions>
      <BaseButton
        :loading="isLoading"
        submitForm
        v-test="'submitForm'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </PageWrap>
</template>

<script
  setup
  lang="ts"
>
import { inject, type Ref } from 'vue';
import PageWrap from '../PageWrap.vue';
import LogoDescription from './LogoDescription.vue';
import type { InvoiceFormData } from './useInvoices';

const emit = defineEmits(['submit']);

const formData = inject<InvoiceFormData>('formData')!;
const isLoading = inject<Ref<boolean>>('isLoading');
</script>
